import React from "react";
import { TestiMonials } from "./Containt_home";
import Calender from "../GetDemo/Calender";
const Demo = ()=>{
    return <div>
    <h1>Select a date for Demo</h1>
    <Calender/>
     <TestiMonials />;
    </div>
}
export default Demo;